import { render } from "./DemoCrudCharView.vue?vue&type=template&id=1ff475a0&scoped=true"
import script from "./DemoCrudCharView.vue?vue&type=script&lang=js"
export * from "./DemoCrudCharView.vue?vue&type=script&lang=js"

import "./DemoCrudCharView.vue?vue&type=style&index=0&id=1ff475a0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ff475a0"]])

export default __exports__